function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.28 54.56C42.3463 54.56 54.56 42.3463 54.56 27.28C54.56 12.2137 42.3463 0 27.28 0C12.2137 0 0 12.2137 0 27.28C0 35.7585 3.86784 43.3336 9.93528 48.3371C9.95075 48.3498 9.93694 48.3747 9.91796 48.3682V48.3682C9.90629 48.3642 9.89415 48.3729 9.89415 48.3852V55.5042C9.89415 58.4834 13.0343 60.4171 15.6947 59.076L23.8465 54.9668C24.511 54.6318 25.2553 54.4961 25.9986 54.5304C26.4233 54.5501 26.8505 54.56 27.28 54.56Z",
  fill: "#147E5F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.4663 20.1555C37.3121 20.799 37.4733 22.0077 36.8256 22.8503L27.2956 35.2496C26.9591 35.6873 26.4492 35.9593 25.8966 35.9958C25.344 36.0323 24.8024 35.8297 24.4108 35.4401L18.3655 29.4254C17.6125 28.6762 17.6125 27.4575 18.3655 26.7083C19.1131 25.9645 20.3212 25.9645 21.0688 26.7083L25.5762 31.1928L33.7847 20.513C34.4278 19.6762 35.6263 19.5164 36.4663 20.1555Z",
  fill: "white"
});

function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.2bf978fc.svg";
export { ForwardRef as ReactComponent };